import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { API } from '@unboared/react';

import styles from './SessionClosedOverlay.module.css';

/**
 * Gamepad-side full-screen overlay shown when the server terminates the
 * session (screen gone for too long, server restart...). Without it the
 * gamepad silently freezes on the last game screen and players have no way
 * to know they must rescan the QR code.
 */
export function SessionClosedOverlay() {
    const { t } = useTranslation();
    const [closed, setClosed] = useState(false);

    useEffect(() => {
        const unsubscribe = API.onSessionClosed(() => setClosed(true));
        return unsubscribe;
    }, []);

    if (!closed) {
        return null;
    }

    return (
        <div className={styles.root}>
            <p className={styles.title}>{t('gamepad.sessionClosed.title')}</p>
            <p className={styles.hint}>{t('gamepad.sessionClosed.hint')}</p>
        </div>
    );
}
